import React, { useState, useEffect } from 'react';
import { getConnectionStatus, onConnectionStatusChange } from '../services/socket';

const ConnectionStatus = ({ className = '' }) => {
  const [status, setStatus] = useState(getConnectionStatus());

  useEffect(() => {
    const unsubscribe = onConnectionStatusChange((newStatus) => {
      setStatus(newStatus);
    });

    return unsubscribe;
  }, []);

  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          color: 'bg-green-500',
          text: 'Connected',
          textColor: 'text-green-700',
          icon: '●'
        };
      case 'connecting':
        return {
          color: 'bg-yellow-500',
          text: 'Connecting...',
          textColor: 'text-yellow-700',
          icon: '●'
        };
      case 'disconnected':
        return {
          color: 'bg-red-500',
          text: 'Disconnected',
          textColor: 'text-red-700',
          icon: '●'
        };
      case 'error':
        return {
          color: 'bg-red-500',
          text: 'Connection Error',
          textColor: 'text-red-700',
          icon: '●'
        };
      default:
        return {
          color: 'bg-gray-500',
          text: 'Unknown',
          textColor: 'text-gray-700',
          icon: '●'
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span 
        className={`inline-block w-2 h-2 rounded-full ${statusConfig.color} animate-pulse`}
        title={`Socket Status: ${statusConfig.text}`}
      />
      <span className={`text-xs font-medium ${statusConfig.textColor}`}>
        {statusConfig.text}
      </span>
    </div>
  );
};

export default ConnectionStatus;
